module.exports = __webpack_public_path__ + "media/images/icons/widget-b9611bd759d8de5cbba16f81b47dfd7c.svg";